<script>
  import LessonDetails from "./LessonDetails.svelte";
  import LessonStore from "../stores/LessonStore.js";
  import { _ } from "svelte-i18n";
  import Saos from "saos";

  export let lesson_ids;
</script>

<div class="lesson-list">
  {#each $LessonStore as lesson (lesson.id)}
    {#if lesson_ids.includes(lesson.id)}
      <Saos
        animation={"scale-in-center 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both"}
      >
        <LessonDetails {lesson} locale_title={$_("lesson-store.title." + lesson.id)} locale_desc={$_("lesson-store.desc." + lesson.id)}/>
      </Saos>
    {/if}
  {/each}
</div>


<style>
  @keyframes -global-scale-in-center {
    0% {
      transform: scale(0);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  .lesson-list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
  }
</style>
